import { PropsWithChildren, useEffect } from 'react';

import { useLocalStore } from '@/hooks/useLocalStore';
import { useWindowWidthResize } from '@/hooks/useWindowWidthResize';

import { RootStore } from './RootStore';
import { RootStoreContext } from './RootStoreContext';

export const RootStoreProvider = ({ children }: PropsWithChildren) => {
  const { store } = useLocalStore(() => new RootStore());

  useEffect(() => store.uiStore.updateScreenSize(), [store.uiStore]);

  useWindowWidthResize(store.uiStore.updateScreenSize);

  return <RootStoreContext.Provider value={store}>{children}</RootStoreContext.Provider>;
};
